import { InvoiceTab } from '@/features/events/components/Detail/Tabs/InvoiceTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id/invoice')({
  component: InvoiceTab,
});
